import { render, staticRenderFns } from "./SelectIndex.vue?vue&type=template&id=2f594536&scoped=true"
import script from "./SelectIndex.vue?vue&type=script&lang=js"
export * from "./SelectIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f594536",
  null
  
)

export default component.exports